import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { PRODUCTION_MENU, PRODUCTION_SECTION } from './constants/menuStructureProject';

export default function ProductionMenu(props) {
  return (
    <GenericMenu 
      menuConfig={PRODUCTION_MENU} 
      sectionsMap={PRODUCTION_SECTION} 
      propsRouter={props} 
    />
  );
}